const { v4: uuidv4 } = require('uuid');


class EnhancedEvent {
  constructor (options) {
    if (!options) {
      throw new Error('construction options required')
    }

    this.id = uuidv4()
    this.version = EnhancedEvent.VERSION
    
    this.timestamp = options.timestamp
    this.type = options.type
    this.page = options.page
    this.pageEntirelyInView = options.pageEntirelyInView
    this.maximumPagePosition = options.maximumPagePosition
    this.movement = options.movement
    this.metadata = options.metadata
    this.additionalData = options.additionalData

    this.error = options.error
    this.errorEventId = options.errorEventId
    
    if (!this.timestamp) {
      this.timestamp = (new Date()).getTime()
    }

    this.time = (new Date(this.timestamp)).toISOString()
    
    if (!this.type) {
      throw new Error('event type required')
    }
    
    if (!this.page) {
      throw new Error('event page required')
    }

    if (!this.pageEntirelyInView) {
      this.pageEntirelyInView = false
    }

    if (!this.maximumPagePosition) {
      this.maximumPagePosition = -1
    }
  }
}

EnhancedEvent.VERSION = '1.0.0';

export default EnhancedEvent
